import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { forkJoin, map, Observable } from 'rxjs';
import { IBaseOneResponse, IGetManyResponse } from '../../shared/model/interface/crud-response-interface.model';
import {
  INotificationGroupResponseData,
  INotificationGroupUserData,
  ISendNotificationGroupModalData,
  ISendNotificationGroupModalParams,
  ISendNotificationMailResponseData,
  ISendNotificationPayload,
} from './send-notification-group.model';
import { IIssuerAndReason } from '../../shared/component/before-action-preparer/before-action-preparer.model';

@Injectable({
  providedIn: 'root',
})
export class SendNotificationGroupService {
  private readonly URLS = {
    NOTIFICATION_GROUP: `${this.baseUrl}/notification-mail-groups/`,
    NOTIFICATION_GROUP_USERS: `${this.baseUrl}/users/users-with-scope`,
    SEND_NOTIFICATION_MAIL: `${this.baseUrl}/notification-mail-sends/`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public getNotificationGroupData(params: HttpParams): Observable<IGetManyResponse<INotificationGroupResponseData>> {
    return this.http.get<IGetManyResponse<INotificationGroupResponseData>>(this.URLS.NOTIFICATION_GROUP, { params });
  }

  private getNotificationGroupUserDropdownData(
    params: HttpParams,
  ): Observable<IGetManyResponse<INotificationGroupUserData>> {
    return this.http.get<IGetManyResponse<INotificationGroupUserData>>(this.URLS.NOTIFICATION_GROUP_USERS, {
      params,
    });
  }

  public getSendNotificationGroupModalData(
    params: ISendNotificationGroupModalParams,
  ): Observable<ISendNotificationGroupModalData> {
    const notificationGroupParams: HttpParams = new HttpParams().append('limit', 5000).append('is_active', true);

    const userDropdownParams: HttpParams = new HttpParams()
      .append('logbook_id', params.logbookId)
      .append('form_id', params.formId);

    return forkJoin({
      notificationGroupData: this.getNotificationGroupData(notificationGroupParams),
      notificationGroupUserDropdownData: this.getNotificationGroupUserDropdownData(userDropdownParams),
    }).pipe(
      map(
        ({ notificationGroupData, notificationGroupUserDropdownData }): ISendNotificationGroupModalData => ({
          notificationGroupData: notificationGroupData?.data ?? null,
          notificationGroupUserDropdownData: notificationGroupUserDropdownData?.data ?? null,
        }),
      ),
    );
  }

  public sendMailNotification(
    payload: ISendNotificationPayload,
    issuerAndReason: IIssuerAndReason,
  ): Observable<IBaseOneResponse<ISendNotificationMailResponseData>> {
    return this.http.post<IBaseOneResponse<ISendNotificationMailResponseData>>(this.URLS.SEND_NOTIFICATION_MAIL, {
      payload,
      issuer: issuerAndReason.issuer,
      reason: issuerAndReason.reason,
    });
  }
}
